// GA4 (gtag) custom events for the web app — mirrors the mobile app's Firebase
// Analytics events so both platforms report the same event names to the shared
// GA4 property. Meta/Pixel events are separate (utils/facebookEvents.js).

function track(name, params) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    try {
      window.gtag('event', name, params || {});
    } catch {
      /* analytics must never break the app */
    }
  }
}

export const ga = {
  // Auth
  signup: (method = 'email') => track('sign_up', { method }),
  login: (method = 'email') => track('login', { method }),

  // Subscription
  trialStart: () => track('trial_start'),
  beginCheckout: ({ amount, currency = 'INR', interval } = {}) =>
    track('begin_checkout', {
      value: amount,
      currency,
      ...(interval && { billing_interval: interval }),
    }),
  purchase: ({ amount, currency = 'INR', interval } = {}) =>
    track('purchase', {
      value: amount,
      currency,
      ...(interval && { billing_interval: interval }),
    }),

  // Content / engagement
  addTransaction: (type = 'expense') => track('add_transaction', { type }),
  editTransaction: () => track('edit_transaction'),
  deleteTransaction: () => track('delete_transaction'),
  addAccount: () => track('add_account'),
  addCategory: () => track('add_category'),
};
